<!--  -->
<template>
  <div class='kaoshi round bj-col-white pad' v-loading="loading" :element-loading-text="loadingText">
    <h3 style="color: #4CC08C;">公需课程：正式考试</h3>
    <div class="time">
      <img src="../../assets/img/daojishi.png" alt="">
      <span>{{residueTime}}</span>
    </div>
    <main>
      <div v-for="(item, index) in list" :key="index">
        <div class="msg">
          <h4>{{index+1}}、【{{item.qst_leix}}题】</h4>
        </div>
        <p>{{item.mingcheng}}</p>
        <div class="xuanze">
          <div v-for="(it, idx) in item.answer_arr" :key="'a' + idx" @click="onChange(index, idx)">
            <div :class="{'xuanzhong': it.checked}">{{it.label}}</div>
            {{it.title}}
          </div>
        </div>
      </div>
    </main>
    <div class="btn">
      <el-button round style="width: 120px" size="mini" type="success" @click="submitRoll()">提交考试</el-button>
    </div>

    <el-dialog
      :visible.sync="visible"
      width="30%"
      top="15vh"
      :close-on-click-modal="false"
      :show-close="true"
      center
      append-to-body>
      <template slot="title">
        <div style="color: #4CC08C;font-size: 20px;font-weight: bolder;">公需考试</div>
      </template>
      <div class="hint">
        <template v-if="score < 60">
          <img src="../../assets/img/error.png" alt="">
          <p><span>很遗憾！考试未通过，请重新考试。</span></p>
          <p>成绩<span style="font-weight: bold;font-size: 28px;">{{ score }}</span>分</p>
          <p>备注：建议您考试之前进行“<span>模拟练习</span>”，正式考试60分合格。</p>
        </template>
        <template v-else>
          <img src="../../assets/img/success.png" alt="">
          <p>恭喜您！考试合格。</p>
          <p>成绩<span style="font-weight: bold;color: #4CC08C;font-size: 28px;">{{ score }}</span>分</p>
          <p>请到“<span style="cursor: pointer;text-decoration:underline" @click="handleLink">广东省执业药师管理系统</span>”查询<span>公需10学分</span>。</p>
        </template>
      </div>
      <span slot="footer">
        <el-button round type="success" class="self-button--success" size="medium" style="width: 110px" @click="handleQuit">我知道了</el-button>
        <template v-if="score < 60">
          <el-button round type="warning" class="self-button--warning" size="medium" style="width: 110px" @click="$router.replace('/gongxu/lianxi')">模拟练习</el-button>
          <el-button round type="primary" class="self-button--primary" size="medium" style="width: 110px" @click="visible = false; list = []; getTopic()">进入考试</el-button>
        </template>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Api from '../../api/gongxu'

export default {
  components: {
    
  },
  data() {
    return {
      loading: false,
      loadingText: '',
      exam_id: '',
      list: [],
      time: '',
      residueTime: '',
      score: 60,
      visible: false,
    };
  },
  computed: {},
  filters: {
    
  },
  watch: {},
  created() {
    this.getTopic()
  },
  mounted() {
    this.init()
  },
  beforeDestroy () {
    document.onkeydown = () => {}
  },
  //方法集合
  methods: {
    // 阻止页面刷新
    init () {
      document.onkeydown = (e) => {
        var evt = window.event || e;
        var k = evt.keyCode || evt.which;
        //屏蔽ctrl+R，F5键，ctrl+F5键  F3键！验证
        if (
          (e.ctrlKey == true && k == 82) ||
          k == 116 ||
          (e.ctrlKey == true && k == 116) ||
          k == 114
        ) {
          this.$message.warning("您的操作会导致本页面重置，考试将重新进行，请谨慎操作！")
          if (evt.preventDefault) {
            evt.preventDefault();
          } else {
            evt.keyCode = 0;
            evt.returnValue = false
          }
        }
        if (k == 8) {
          this.$message.warning("您的操作会导致本页面重置，考试将重新进行，请谨慎操作！")
          if (evt.preventDefault) {
            evt.preventDefault();
          } else {
            evt.keyCode = 0;
            evt.returnValue = false
          }
        }
        //屏蔽 Ctrl+n   验证可以实现效果
        if (e.ctrlKey && k == 78) {
          this.$message.warning("您的操作会导致本页面重置，考试将重新进行，请谨慎操作！")
          if (evt.preventDefault) {
            evt.preventDefault();
          } else {
            evt.keyCode = 0;
            evt.returnValue = false
          }
        }
        //屏蔽 Alt+ 方向键 ← ;屏蔽 Alt+ 方向键 → ！验证
        if (e.altKey && (k == 37 || k == 39)) {
          this.$message.warning("您的操作会导致本页面重置，考试将重新进行，请谨慎操作！")
          if (evt.preventDefault) {
            evt.preventDefault();
          } else {
            evt.keyCode = 0;
            evt.returnValue = false
          }
        }
      };
    },
    // 获取题目信息
    getTopic () {
      this.loading = true
      Api.getKsTopic().then(res => {
        this.loading = false
        this.exam_id = res.data.data.exam_id
        let list = res.data.data.list
        list.forEach((item) => {
          item.answer = ''
          item.answer_arr = [
            {
              label: 'A',
              checked: false,
              title: item.answer_a
            },
            {
              label: "B",
              checked: false,
              title: item.answer_b
            },
            {
              label: 'C',
              checked: false,
              title: item.answer_c
            },
            {
              label: 'D',
              checked: false,
              title: item.answer_d
            }
          ]
          item.answer_arr = item.answer_arr.splice(0, Number(item.answer_num))
          if (item.qst_type == 3) {
            item.answer_arr = [item.answer_arr[0], item.answer_arr[1]]
          }
        });
        this.list = list
        this.time = res.data.data.time
        this.residueTime = this.changeTime(this.time)
        this.setTime()
      })
    },
    // 记算倒计时
    setTime () {
      let time = this.time
      let dateTime = setInterval(() => {
        time--
        this.time = time
        if (time == 0) {
          clearInterval(dateTime)
          this.submitRoll()
        }
        this.residueTime = this.changeTime(time)
      }, 1000)
      this.dateTime = dateTime
    },
    // 时间转换
    changeTime (time) {
      let min = Math.floor(time / 60);
      let sec = Math.floor(((time % 86400) % 3600) % 60);
      min = min < 10 ? '0' + min : min
      sec = sec < 10 ? '0' + sec : sec
      return min+'分钟'+sec+'秒'
    },
    onChange (index, idx) {
      let info = this.list[index]
      info.answer_arr[idx].checked = !info.answer_arr[idx].checked
      if (info.qst_type != 2) {
        for (let i in info.answer_arr) {
          if (Number(i) != idx) {
            info.answer_arr[i].checked = false
          }
        }
      }
      info.answer = ''
      info.answer_arr.forEach(item => {
        if (item.checked) {
          info.answer+=item.label
        }
      })
      this.list[index] = info
    },
    // 交卷
    submitRoll () {
      this.loading = true
      this.loadingText = '正在核验'
      let list = []
      this.list.forEach(item => {
        list.push({
          qst_id: item.qst_id,
          answer: item.answer
        })
      })
      // 结束考试
      Api.submitRoll({
        answer: list,
        exam_id: this.exam_id
      }).then((res) => {
        this.loading = false
        this.visible = true
        this.score = res.data.data.sore
        // this.score = 60
      })
    },
    handleLink () {
      window.open('http://zyys.gdfda.org/queryCredit')
    },
    handleQuit () {
      this.visible = false
      this.$router.go(-1)
    }
  },
}
</script>

<style lang='less' scoped>
.kaoshi {
  position: relative;
  > div {
    width: 90%;
  }
  .time {
    width: fit-content;
    position: absolute;
    top: 20px;
    right: 12%;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 25px;
    }
    span {
      font-size: 18px;
    }
  }
  > main {
    margin-top: 20px;
    max-height: 600px;
    overflow-y: auto;
    .msg {
      margin: 40px 0 20px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      h4, div {
        color: @default;
      }
    }
    p {
      width: 90%;
      word-break: break-all;
      font-weight: 400;
      line-height: 25px;
    }
    .xuanze {
      > div {
        display: flex;
        align-items: center;
        margin-top: 20px;
        cursor: pointer;
        width: fit-content;
        div {
          border: 1px solid #d8d8d8;
          width: 25px;
          height: 25px;
          line-height: 25px;
          margin-right: 10px;
          text-align: center;
          border-radius: 50%;
          background-color: #fff;
        }
        .xuanzhong {
          border-color: @default;
          color: #fff;
          background-color: @default;
        }
      }
    }
  }
  .btn {
    margin: 120px 0 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.hint {
  display: flex;
  flex-direction: column;
  align-items: center;
  > img {
    width: 100px;
    margin-bottom: 20px;
  }
  > p {
    margin-bottom: 15px;
    &:last-child {
      margin-bottom: 0;
    }
    > span {
      color: red;
    }
    .btn {
      display: inline-block;
      margin: 0 5px;
      padding: 2px 8px;
      background-color: red;
      color: #fff;
      border-radius: 4px;
      cursor: pointer;
    }
  }
}
</style>